module.exports = __webpack_public_path__ + "static/media/interested.8c4203f6.svg";